import { client, orpc } from "@/utils/orpc.client";
import { QUERY_STALE_TIMES } from "@/utils/query-policies";

export const ADMIN_ANALYTICS_RANGES = ["24h", "7d", "30d", "90d"] as const;
export type AdminAnalyticsRange = (typeof ADMIN_ANALYTICS_RANGES)[number];
export type AdminDeliveryAnalytics = Awaited<ReturnType<typeof client.notificationAnalytics.get>>;

export function getAdminDeliveryAnalyticsQueryOptions(range: AdminAnalyticsRange) {
  return {
    ...orpc.notificationAnalytics.get.queryOptions({ input: { range } }),
    staleTime: QUERY_STALE_TIMES.adminAnalytics,
    refetchOnMount: true,
  };
}
